module.exports = __webpack_public_path__ + "img/60.b58fcb58.jpg";